const reCaptchaState = {
  initCounter: 0,
  injectScript: false
}

class ReCaptchaElement {
  sequence = -1;
  reCaptchaId;
  rendered = false;
  options = {
    type: 'inline',
    action: 'submit'
  };

  /**
   *
   * @param sequence : number
   * @param options : object - {
   *    action: string,
   *    type: ?string,
   *    badge: ?string,
   *    tabIndex: ?number,
   *    size: ?string,
   *    actorSelector: ?string,
   *    containerSelector: ?string,
   *    onSuccess: ?function,
   *    onError: ?function
   * }
   */
  constructor(sequence, options) {
    this.sequence = sequence;
    this.options = options;
  };

  isRendered() {
    return this.rendered;
  }

  /**
   *
   * @param value : boolean
   */
  setRendered(value) {
    this.rendered = value
  }

  /**
   * @param reCaptchaId : string
   */
  setReCaptchaId(reCaptchaId) {
    this.reCaptchaId = reCaptchaId;
  };

  setToken(token) {
  };

  setError() {
  };
}

class EventsReCaptcha {
  siteKey = null;
  version = 2;
  language = null;
  items = [];
  sequence = 0;
  needHideBadge = false;

  constructor(Vue, options) {
    this.configure(options);
  }

  configure({ siteKey, version, language, hideBadge }) {
    if (!siteKey) {
      console.error('Please set site key for google reCaptcha')
    }

    this.siteKey = siteKey;

    if (version) {
      this.version = version
    }
    if (language) {
      this.language = language
    }

    this.needHideBadge = (hideBadge === true);
  };

  injectScript() {
    this.version === 3 ? this.injectScriptV3() : this.injectScriptV2()
  };

  injectScriptV2() {
    const self = this;
    if (typeof window === 'undefined' || reCaptchaState.injectScript === true) {
      return;
    }
    reCaptchaState.injectScript = true;
    window.onLoadGoogleReCaptcha = () => {
      reCaptchaState.initCounter++;
      self.rendering();
    };
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute(
      'src',
      'https://www.google.com/recaptcha/api.js?onload=onLoadGoogleReCaptcha&render=explicit'
      + (this.language ? `&hl=${this.language}` : '')
    );
    recaptchaScript.setAttribute('async', '');
    recaptchaScript.setAttribute('defer', '');
    (document.head || document.body).appendChild(recaptchaScript);

    if (this.needHideBadge) {
      this.hideBadge();
    }
  };

  injectScriptV3() {
  };

  hideBadge() {
    const style = document.createElement('style');
    style.innerHTML = '.grecaptcha-badge { visibility: hidden; }';
    (document.head || document.body).appendChild(style);
  };

  checkDelay = 300;
  checkTimer = null;
  startCheck() {
    if (this.checkTimer) {
      window.clearInterval(this.checkTimer)
    }
    this.checkTimer = window.setInterval(this.rendering.bind(this), this.checkDelay)
  };

  /**
   * рендеринг всех капч после подгрузки js google recaptcha
   */
  rendering() {
    this.items.forEach((item) => {
      if (item && item.data && !item.data.isRendered()) {
        this.render(item);
      }
    });
  };

  /**
   * Добавить для элемента капчу и если загружен js, то отрендерить капчу
   * @param htmlNode : HTMLElement
   * @param options : object - {
   *    action: string,
   *    type: ?string,
   *    badge: ?string,
   *    tabIndex: ?number,
   *    size: ?string,
   *    actorSelector: ?string,
   *    containerSelector: ?string,
   *    onSuccess: ?function,
   *    onError: ?function
   * }
   */
  add(htmlNode, options) {
    const currentSequence = this.sequence++;
    htmlNode.dataset.reCaptchaSequence = currentSequence.toString();

    // объект для состояния тек. капчи
    const element = new ReCaptchaElement(currentSequence, options);

    // запомнить созданный элемент и контекст
    this.items[currentSequence] = { htmlNode: htmlNode, wrapper: null, data: element };

    // навешиваем клик-обработчик сразу, не дожидаясь загрузки js google recaptcha,
    // чтобы кнопка реагировала, даже если api.js заблокирован/не загрузился
    // (напр. Яндекс Браузер на iOS режет запросы к google.com/recaptcha)
    this.attachClickHandler(this.items[currentSequence]);

    // если скрипт уже зогружен, то можно сразу отрендерить
    if (reCaptchaState.initCounter > 0) {
      this.render(this.items[currentSequence]);
    }
  };

  /**
   * навесить клик-обработчик на элемент (или actorSelector).
   * Вызывается из add() до загрузки recaptcha, чтобы клик работал всегда:
   *  - если капча отрендерена  -> запускаем капчу (run)
   *  - если капча не загрузилась -> пропускаем капчу и отправляем форму напрямую
   * @param item : object - {}
   */
  attachClickHandler(item) {
    if (!item || !item.data || item.clickAttached) {
      return;
    }
    item.clickAttached = true;

    const options = item.data.options;

    const runAction = () => {
      try {
        // валидация формы (onBeforeAction) может вернуть false или бросить ошибку
        if (typeof options.onBeforeAction === 'function' && !options.onBeforeAction()) {
          return false;
        }
      } catch (e) {
        if (typeof options.onError === 'function') {
          options.onError(e);
        }
        return false;
      }

      const reCaptchaReady = item.data.isRendered()
        && typeof window !== 'undefined'
        && window.grecaptcha
        && typeof window.grecaptcha.execute === 'function';

      try {
        if (reCaptchaReady) {
          // штатный сценарий — запускаем капчу
          this.run(item);
        } else {
          // капча не загрузилась — отправляем форму без токена капчи
          if (typeof options.onSuccess === 'function') {
            options.onSuccess({ token: null, action: options.action });
          }
        }
      } catch (e) {
        // если запуск капчи упал — фолбэк на прямую отправку
        if (typeof options.onSuccess === 'function') {
          options.onSuccess({ token: null, action: options.action });
        }
      }
      return true;
    };

    if (typeof options.actorSelector === 'undefined') {
      item.htmlNode.addEventListener('click', (event) => {
        event.preventDefault();
        return runAction();
      });
    } else if (options.actorSelector !== null) {
      window.document.querySelectorAll(options.actorSelector).forEach((actor) => {
        actor.addEventListener('click', (event) => {
          event.preventDefault();
          return runAction();
        });
      });
    }
  };
  /**
   * Удалить элемент
   * @param htmlNode : HTMLElement
   * @param options : object
   */
  remove(htmlNode, options) {
    let sequence;
    if (typeof htmlNode.dataset.reCaptchaSequence === 'undefined') {
      console.info(
        'try remove reCaptcha from,  but not exists reCaptchaSequence in dataset',
        htmlNode
      )
      return;
    }
    sequence = parseInt(htmlNode.dataset.reCaptchaSequence);
    if (isNaN(sequence)) {
      console.info(
        'try remove reCaptcha, but reCaptchaSequence['
        + htmlNode.dataset.reCaptchaSequence + '] in dataset is no number',
        htmlNode
      )
      return;
    }
    if (this.items[sequence]) {
      this.destroy(this.items[sequence]);
    }
    this.items[sequence] = null;
    delete(this.items[sequence]);
    delete htmlNode.dataset.reCaptchaSequence;
  };
  /**
   * отрендерить для элемента капчу
   * @param item : object - {}
   */
  render(item) {

    if (typeof window === 'undefined') {
      return;
    }

    if (typeof window.grecaptcha === 'undefined' || !grecaptcha in window) {
      console.error('try render, but not loaded js https://www.google.com/recaptcha/api.js');
      return;
    }

    if (typeof window.grecaptcha.render !== 'function') {
      console.error('try render, but not available window.grecaptcha.render function');
      return;
    }

    if (!item || !item.data) {
      console.error('try render empty item or item.data');
      return;
    }

    const options = item.data.options;

    try {

      // сформировать параметры для рендеринга капчи
      const captchaParams = {
        sitekey: this.siteKey,
      };
      if (options.badge) captchaParams.badge = options.badge;
      if (options.type) captchaParams.type = options.type;
      if (options.tabIndex) captchaParams.tabindex = options.tabIndex;
      if (typeof options.size === 'undefined') {
        captchaParams.size = 'invisible';
        captchaParams.callback = this.setToken.bind(this, { sequence: item.data.sequence });
      }

      // HTML элемент в котором будет располагаться капча
      const wrapper = document.createElement('div');
      wrapper.className = 'recaptcha__wrapper';
      wrapper.style.position = 'relative';
      wrapper.style.zIndex = '100';

      // поиск элемента в который будет добавлена отрендеренная капча
      let container = null;
      if (typeof options.containerSelector !== 'undefined') {
        container = window.document.querySelector(options.containerSelector);
        if (container) {
          container = container[0];
        }
      }
      // если не нашли контейнер в который будет добавлена капча, то добавляем в текущий элемент
      if (!container) {
        container = item.htmlNode;
      }

      container.parentNode.insertBefore(wrapper, container.nextSibling);

      // генерация капчи в добавленном контейнере
      const recaptchaId = window.grecaptcha.render(wrapper, captchaParams);
      item.data.setRendered(true);
      item.data.setReCaptchaId(recaptchaId);

      // клик-обработчик навешивается в add()/attachClickHandler ещё до загрузки
      // recaptcha, поэтому здесь его навешивать не нужно

    } catch (e) {
      console.error(e);
      if (options && typeof options.onError === 'function') {
        options.onError(e);
      }
    }
  };
  /**
   * разрушить для элемента капчу
   * @param item : object - {
   *   @var data: ReCaptchaElement
   * }
   */
  destroy(item) {

    if (typeof window === 'undefined') {
      return;
    }

    if (typeof window.grecaptcha === 'undefined') {
      console.warn('try destroy, but js[https://www.google.com/recaptcha/api.js] not loaded yet');
      return;
    }

    if (!item.data.recaptchaId) {
      console.warn('captcha element has\'t recaptcha id');
      return;
    }
    window.grecaptcha.reset(item.data.recaptchaId);
  };
  setToken(params, token) {
    if (typeof window === 'undefined') {
      return;
    }
    if (typeof params.sequence === 'undefined' || !this.items[params.sequence]) {
      return;
    }
    const options = this.items[params.sequence].data.options;

    try {
      if (typeof this.items[params.sequence] !== 'undefined') {
        window.grecaptcha.reset(this.items[params.sequence].data.recaptchaId);
      }
      if (typeof options.onSuccess === 'function') {
        options.onSuccess({ token: token, action: options.action });
      }
    } catch (e) {
      console.error(e);
      if (typeof options.onError === 'function') {
        options.onError(e);
      }
    }
  };

  run(item) {
    if (typeof window === 'undefined') {
      return;
    }
    window.grecaptcha.execute(item.data.reCaptchaId);
  };

  async manualRun(sequence) {
    if (typeof window === 'undefined') {
      return;
    }
    if (!this.items[sequence]) {
      return;
    }
    return window.grecaptcha.execute(this.items[sequence].data.reCaptchaId);
  };
}


export const ReCaptchaPlugin = {
  install(Vue, options) {
    const reCaptcha = new EventsReCaptcha(Vue, options);
    Vue.prototype.$eventsReCaptcha = reCaptcha;
    // 1xreCaptcha.startCheck()
    Vue.mixin(
      {
        data() {
          return { reCaptchaState: reCaptchaState };
        }
      }
    );
    Vue.directive('re-captcha', {
      bind(el, binding, vnode, oldVnode) {
        //console.info('  RC --> bind ', el);
        reCaptcha.injectScript();
      },
      inserted(el, binding, vnode, oldVnode) {
        //console.info('  RC --> inserted ', el );
        reCaptcha.add(el, binding.value);
      },
      //update(el, binding, vnode, oldVnode) {},
      unbind(el, binding, vnode, oldVnode) {
        //console.info('  RC --> unbind ', el);
        reCaptcha.remove(el, binding.value);
      }
    });
  },
}



// WEBPACK FOOTER //
// ./src/plugins/ReCaptcha/ReCaptchaPlugin.js